export default __webpack_public_path__ + "static/media/profileIcon.e468c7bf.jpg";